// Generated by scripts/generate_component_entries.mjs from packages/client/component-entries.json.
// Do not edit by hand.
import type {Alpine as AlpineType} from 'alpinejs';

import {registerInput as registerComponent} from './index';

const registered = new WeakSet<AlpineType>();

const registerInput = (AlpineInstance: AlpineType): void => {
    if (registered.has(AlpineInstance)) return;
    registered.add(AlpineInstance);

    registerComponent(AlpineInstance);
};

export {registerInput};
export default registerInput;
export * from './index';
